



































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import DaisyMessage from '@/domain/daisy-message/entity/daisy-message.entity';
import DaisyMessageService from '@/domain/daisy-message/service/daisy-message.service';
import DaisyMessageErrorHandler from '@/domain/daisy-message/service/daisy-message-error.handler';
import MessageTypes from '../daisy-message-types.json';

@Component({
  components: {
    ModalComponent,
    LabelSlot,
  },
})
export default class DaisyMessageFormModalComponent extends Vue {
  @Prop({
    type: Boolean,
  }) openModal!: boolean;

  @Prop() message!: DaisyMessage;

  @Prop({
    type: Array,
    default: () => [],
  }) existingLanguages!: string[];

  @Prop({
    type: Boolean,
  }) hasDeleteDaisyMessage!: boolean;

  rules: Rules = new Rules();

  messageTypes = MessageTypes;

  loading: boolean = false;

  get isUpdate(): boolean {
    return this.message.isUpdate;
  }

  get modalTitle(): string {
    return this.isUpdate ? 'Editar Mensagem da Daisy' : 'Nova Mensagem da Daisy';
  }

  get videoTitleRules(): Array<(value: string) => boolean | string> {
    return [
      (value: string) => !(!!this.message.videoUrl && !value)
        || 'Informe o título ou remova a URL do vídeo.',
    ];
  }

  get videoUrlRules(): Array<(value: string) => boolean | string> {
    return [
      (value: string) => !(!!this.message.videoTitle && !value)
        || 'Informe a URL ou remova o título do vídeo.',
    ];
  }

  revalidateVideoFields(): void {
    const { videoTitleField, videoUrlField }: any = this.$refs;
    if (videoTitleField) videoTitleField.validate();
    if (videoUrlField) videoUrlField.validate();
  }

  get options(): ModalOptions {
    return {
      title: this.modalTitle,
      titleSize: '20px',
      description: '',
      showOk: true,
      loadingOk: this.loading,
      labelOk: 'Salvar',
      okColor: 'primary',
      showCancel: !this.loading,
      labelCancel: 'Fechar',
      width: 800,
    };
  }

  save(): void {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    if (this.isUpdate) {
      this.update();
      return;
    }
    this.create();
  }

  create(): void {
    this.loading = true;
    DaisyMessageService.create(this.message.toNewRequest())
      .then(() => {
        VbSnackbarService.showSuccess('Mensagem criada com sucesso.');
        this.closeModal();
      })
      .catch(DaisyMessageErrorHandler.handle)
      .finally(() => this.loading = false);
  }

  update(): void {
    this.loading = true;
    DaisyMessageService.update(this.message.id, this.message.toUpdateRequest())
      .then(() => {
        VbSnackbarService.showSuccess('Mensagem atualizada com sucesso.');
        this.closeModal();
      })
      .catch(DaisyMessageErrorHandler.handle)
      .finally(() => this.loading = false);
  }

  closeModal(): void {
    const { form }: any = this.$refs;
    if (form) form.resetValidation();
    this.$emit('closeModal');
  }
}
